import { Rarity, Tag, type ModDef } from '../../sim/mods';
import { Stat } from '../../sim/stats';

/* ═══════════════════════════════════════════════════════════════════════════
   Cartes de BOUCLIER JOUEUR.

   Le bouclier est un système à capacité NULLE de série (voir `stats.ts`,
   `maxShield`) : sans cette carte, un vaisseau n'a pas de barrière du tout. C'est
   délibéré — le bouclier est une VOIE de build défensive qu'on choisit, pas un
   filet offert à tout le monde qui déplacerait la difficulté de base.

   ── Une seule carte, et pourquoi ─────────────────────────────────────────────
   Une carte purement défensive (zéro DPS) dilue le DPS d'un build aléatoire, et
   la courbe de puissance §6.7 est calibrée serré : une SECONDE carte de bouclier
   la faisait déborder du plancher offensif (voir `tests/balance/curve.test.ts`,
   qui mesure désormais ce plancher sur le pool HORS cartes purement défensives).
   Une seule carte, empilable deux fois, suffit à offrir la voie sans casser la
   courbe. Les paliers supplémentaires (recharge accélérée, barrière permanente)
   sont une voie de méta-progression à venir, là où ils ne pèsent pas sur le pool
   de cartes offensif.

   ⚠️ La capacité s'écrit toujours en `add` : `maxShield` part de zéro, et un
   modificateur `mul` sur zéro reste zéro — il ne débloquerait jamais rien.
   ═══════════════════════════════════════════════════════════════════════════ */

const mods: ModDef[] = [
  {
    id: 'plaque-bouclier',
    name: 'Plaque de champ',
    rarity: Rarity.Rare,
    // Orbital : la famille des cartes de survie (vies, frôlement, stabilité). Le
    // bouclier y a naturellement sa place, et cela le fait entrer dans les mêmes
    // synergies de build défensif.
    tags: [Tag.Orbital],
    // Empilable deux fois : une barrière à deux charges reste loin du plafond de
    // sécurité (`STAT_CAPS.maxShield`), et laisse la place au condensateur. Chaque
    // plaque accélère aussi un peu la recharge, sinon la seconde charge mettrait
    // une éternité à revenir.
    maxStacks: 2,
    modifiers: [
      { stat: Stat.MaxShield, op: 'add', value: 1 },
      { stat: Stat.ShieldRegen, op: 'add', value: 0.25 },
    ],
    text: '+1 charge de bouclier, régénération +0,25/s',
  },
];

export default mods;
